import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';


if (typeof window !== 'undefined') {
  if (!window.crypto) {
    (window as any).crypto = {
      getRandomValues: (array: any) => {
        const buffer = new Uint8Array(array.length);
        for (let i = 0; i < array.length; i++) {
          buffer[i] = Math.floor(Math.random() * 256);
        }
        array.set(buffer);
        return array;
      }
    };
  }

  // Garante que o objeto subtle existe (necessário para versões mais novas do Keycloak)
  if (window.crypto && !window.crypto.subtle) {
    (window.crypto as any).subtle = {
      digest: () => Promise.reject('Polyfill não suporta operações avançadas')
    };
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
